import { fabric } from 'fabric';

// Centers a new object on the slide, nudged by up to 5% of the slide size
// so objects added one after another don't sit exactly on top of each
// other. The canvas element is the slide scaled by the zoom.
export const placeNearSlideCenter = (
  canvas: fabric.Canvas,
  object: fabric.Object,
) => {
  const zoom = canvas.getZoom() || 1;
  const slideWidth = canvas.getWidth() / zoom;
  const slideHeight = canvas.getHeight() / zoom;
  const nudge = (size: number) => (Math.random() - 0.5) * 0.1 * size;
  object.set({
    left: (slideWidth - object.getScaledWidth()) / 2 + nudge(slideWidth),
    top: (slideHeight - object.getScaledHeight()) / 2 + nudge(slideHeight),
  });
  object.setCoords();
};
